module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "wrap1"
  }, [_c('div', {
    staticClass: "mod1"
  }, [_c('span', {
    staticClass: "word1"
  }, [_vm._v("实物清单")]), _vm._v(" "), _c('img', {
    staticClass: "material-list-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/编组 3.svg'
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("为了保证实验正常进行，请您尽快寄送实验所需物品")]), _vm._v(" "), _c('div', {
    staticClass: "mod2"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('img', {
    staticClass: "label3",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/提示语.svg'
    }
  }), _vm._v(" "), (_vm.waitSendOutMaterialNumber === 0) ? _c('span', {
    staticClass: "word3"
  }, [_vm._v("您已寄出所有实物")]) : _c('span', {
    staticClass: "word3"
  }, [_vm._v("有" + _vm._s(_vm.waitSendOutMaterialNumber) + "个实物待寄出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap2 flex-row"
  }, [_c('div', {
    staticClass: "sample-block",
    staticStyle: {
      "margin-right": "11px"
    }
  }, [_c('div', {
    staticClass: "wrap3 flex-row",
    on: {
      "click": _vm.createSampleDeliverySheet
    }
  }, [_c('img', {
    staticClass: "sample-delivery-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/新建送样单.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sample-delivery-text"
  }, [_vm._v("寄送实物")])])]), _vm._v(" "), _c('div', {
    staticClass: "sample-block"
  }, [_c('div', {
    staticClass: "wrap3 flex-row",
    on: {
      "click": _vm.showSampleDeliverySheet
    }
  }, [_c('img', {
    staticClass: "sample-delivery-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/查看送样单.svg'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sample-delivery-text"
  }, [_vm._v("寄送记录")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap4 flex-row"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("实物清单")]), _vm._v(" "), _c('span', {
    staticClass: "word6",
    on: {
      "click": _vm.downloadAllInformationSheets
    }
  }, [_vm._v("下载全部物品信息表")])]), _vm._v(" "), _vm._l((_vm.orderMaterialInfo), function(material, index) {
    return _c('div', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "wrap5",
      on: {
        "click": function($event) {
          return _vm.queryMaterial(material)
        }
      }
    }, [_c('div', {
      staticClass: "bd4"
    }, [_c('div', {
      staticClass: "mod4"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "materialType": material.orderMaterial.materialType,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "group3 flex-col"
    }, [_c('div', {
      staticClass: "group4 flex-row"
    }, [_c('span', {
      staticClass: "word7"
    }, [_vm._v(_vm._s(material.orderMaterial.materialDesc))]), _vm._v(" "), _c('display-icon-and-status', {
      attrs: {
        "displayStatusName": material.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "txt2"
    }, [_vm._v("用于" + _vm._s(material.orderMaterial.euName))])]), _vm._v(" "), _c('img', {
      staticClass: "right-icon",
      attrs: {
        "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'
      }
    })])])])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap6"
  }, [_c('span', {
    staticClass: "txt8"
  }, [_vm._v("点击可查看送样指南、")]), _vm._v(" "), _c('span', {
    staticClass: "txt8",
    staticStyle: {
      "color": "rgba(254, 101, 77, 1)"
    }
  }, [_vm._v("下载实物信息表")]), _vm._v(" "), _c('span', {
    staticClass: "txt8"
  }, [_vm._v("并查看送样记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c23cd822","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/SampleDeliveryList.vue
// module id = 1718
// module chunks = 8